import React from 'react';
import cc from 'classcat';

interface LogoProps {
  maxWidth: number;
  darkVersion?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const Logo: React.FC<LogoProps> = ({
  maxWidth,
  darkVersion,
  className = '',
  style
}) => {
  const _style = Object.assign({ maxWidth: `${maxWidth}px` }, style);
  const classes = cc(['sharp-image', className ? className : undefined]);
  const dark = darkVersion ? '' : '-inverse';
  const src = `/static/images/caresignal-logo${dark}-v2.png`;
  return (
    <img src={src} className={classes} alt="CareSignal Logo" style={_style} />
  );
};

export default Logo;
